import chunk from 'lodash/chunk';

// eslint-disable-next-line no-empty-function
const noop = () => {};

export default (items, chunkSize, chunkCallback, progressCallback = noop) => {
  const chunkedItems = chunk(items, chunkSize);

  return chunkedItems.reduce(async (acc, itemsChunk) => {
    const processedItems = await acc + itemsChunk.length;
    await chunkCallback(itemsChunk);
    const percentage = (processedItems / items.length) * 100;

    progressCallback(percentage);
    return processedItems;
  }, 0);
};
